// Server-side API URL: uses localhost to avoid Cloudflare round-trip + ETIMEDOUT issues during SSR.
// API_URL (runtime, server-only) > NEXT_PUBLIC_API_URL (build-time, both) > fallback
export const SERVER_API_URL = process.env.API_URL || process.env.NEXT_PUBLIC_API_URL || 'http://localhost:3001/api';
